import logo from '../assets/logo.png';

const POSE_URLS = import.meta.glob('./mascots/*.{svg,png}', {
    eager: true,
    query: '?url',
    import: 'default',
});

function urlForPose(pose) {
    if (!pose) return null;
    for (const [path, url] of Object.entries(POSE_URLS)) {
        const file = path.split('/').pop() || '';
        if (file === `${pose}.svg` || file === `${pose}.png`) return url;
    }
    return null;
}

export function TourStepProgress({ stepIndex, stepCount }) {
    const label = `${stepIndex + 1} / ${stepCount}`;
    return (
        <div className="tour-progress">
            <div className="tour-dots" aria-hidden="true">
                {Array.from({ length: stepCount }, (_, i) => (
                    <span
                        key={i}
                        className={`tour-dot${i === stepIndex ? ' is-current' : ''}`}
                    />
                ))}
            </div>
            <span className="visually-hidden">{label}</span>
        </div>
    );
}

export default function TourMascot({ pose, fallback = 'none', size = 'tip' }) {
    const src = urlForPose(pose) || (fallback === 'logo' ? logo : null);
    if (!src) return null;
    return (
        <img
            className={`tour-mascot tour-mascot--${size}`}
            src={src}
            alt=""
            draggable={false}
        />
    );
}
